import { jsx } from "react/jsx-runtime";
import React from "react";
import {
  getSequenceWithinRange,
  zeroSubrangeByContainerRange
} from "@teselagen/range-utils";
import AASliver from "./AASliver";
import { pureNoFunc } from "@teselagen/ui";
import { proteinAlphabet } from "@teselagen/sequence-utils";
class Translation extends React.Component {
  state = {
    hasMounted: false
  };
  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({
        hasMounted: true
      });
    }, 5);
  }
  componentWillUnmount() {
    !window.Cypress && clearTimeout(this.timeout);
  }
  render() {
    const {
      annotationRange,
      height,
      showAminoAcidNumbers,
      showAminoAcidUnitAsCodon,
      charWidth,
      aminoAcidNumbersHeight,
      onClick,
      onRightClick,
      onDoubleClick,
      sequenceLength,
      getGaps,
      colorType,
      isProtein
    } = this.props;
    const { hasMounted } = this.state;
    const { annotation } = annotationRange;
    if (!hasMounted && !isProtein) {
      return /* @__PURE__ */ jsx("g", { height, className: "translationLayer" });
    }
    const { aminoAcids = [] } = annotation;
    const subrangeStartRelativeToAnnotationStart = zeroSubrangeByContainerRange(
      annotationRange,
      annotation,
      sequenceLength
    );
    const aminoAcidsForSubrange = getSequenceWithinRange(
      subrangeStartRelativeToAnnotationStart,
      aminoAcids
    );
    let prevAaSliver;
    let nextAaSliver = aminoAcidsForSubrange[1];
    const lastIndex = aminoAcidsForSubrange.length - 1;
    const translationSVG = aminoAcidsForSubrange.map(
      function(aminoAcidSliver, index) {
        if (aminoAcidSliver.positionInCodon === null) {
          prevAaSliver = aminoAcidSliver;
          nextAaSliver = aminoAcidsForSubrange[index + 2];
          return /* @__PURE__ */ jsx(
            "rect",
            {
              x: index * charWidth,
              y: height / 2 - height / 16,
              width: charWidth,
              height: height / 8,
              fill: "grey",
              stroke: "black",
              strokeWidth: 1
            },
            annotation.id + aminoAcidSliver.sequenceIndex
          );
        }
        const isEndFiller = (index === 0 || prevAaSliver?.positionInCodon === null) && aminoAcidSliver.positionInCodon === (annotation.forward ? 2 : 0);
        const isStartFiller = (index === lastIndex || nextAaSliver?.positionInCodon === null) && aminoAcidSliver.positionInCodon === (annotation.forward ? 0 : 2);
        let isTruncatedEnd = (index === 0 || prevAaSliver?.positionInCodon === null) && aminoAcidSliver.positionInCodon === 1;
        let isTruncatedStart = (index === lastIndex || nextAaSliver?.positionInCodon === null) && aminoAcidSliver.positionInCodon === 1;
        if (!annotation.forward) {
          const holder = isTruncatedEnd;
          isTruncatedEnd = isTruncatedStart;
          isTruncatedStart = holder;
        }
        if (aminoAcidSliver.positionInCodon !== 1 && !isStartFiller && !isEndFiller) {
          prevAaSliver = aminoAcidSliver;
          nextAaSliver = aminoAcidsForSubrange[index + 2];
          return null;
        }
        const { gapsInside, gapsBefore } = getGaps(aminoAcidSliver.codonRange);
        const gapsInsideFeatureStartToBp = getGaps({
          start: annotationRange.start,
          end: aminoAcidSliver.sequenceIndex
        }).gapsInside;
        const relativeAAPositionInTranslation = index;
        const aminoAcid = aminoAcidSliver.aminoAcid || {};
        const alphVal = proteinAlphabet[aminoAcid.value];
        let color;
        if (alphVal) {
          color = colorType === "byHydrophobicity" ? alphVal.color : alphVal.colorByFamily;
        } else {
          color = aminoAcid.color;
        }
        prevAaSliver = aminoAcidSliver;
        nextAaSliver = aminoAcidsForSubrange[index + 2];
        return /* @__PURE__ */ jsx(
          AASliver,
          {
            isFiller: isEndFiller || isStartFiller || isTruncatedEnd && isTruncatedStart,
            isTruncatedEnd,
            isTruncatedStart,
            onClick: function(event) {
              onClick({
                annotation: aminoAcidSliver.codonRange,
                codonRange: aminoAcidSliver.codonRange,
                event,
                gapsInside,
                gapsBefore
              });
            },
            onContextMenu: function(event) {
              onRightClick && onRightClick({
                annotation,
                codonRange: aminoAcidSliver.codonRange,
                event,
                gapsInside,
                gapsBefore
              });
            },
            title: `${aminoAcid.name} -- Index: ${aminoAcidSliver.aminoAcidIndex + 1} -- Hydrophobicity: ${aminoAcid.hydrophobicity} -- Mass: ${aminoAcid.mass}

Part of ${annotation.translationType} Translation from BPs ${annotation.start + 1} to ${annotation.end + 1} (${aminoAcids.length / 3} ${showAminoAcidUnitAsCodon ? "codons" : "AAs"})`,
            showAminoAcidNumbers,
            aminoAcidIndex: aminoAcidSliver.aminoAcidIndex,
            onDoubleClick: function(event) {
              onDoubleClick({ annotation, event });
            },
            getGaps,
            forward: annotation.forward,
            width: charWidth,
            height: showAminoAcidNumbers ? height - aminoAcidNumbersHeight : height,
            relativeAAPositionInTranslation: relativeAAPositionInTranslation + gapsInsideFeatureStartToBp,
            letter: aminoAcid.value,
            color,
            positionInCodon: aminoAcidSliver.positionInCodon
          },
          annotation.id + aminoAcidSliver.sequenceIndex
        );
      }
    );
    return /* @__PURE__ */ jsx("g", { className: "translationLayer", children: translationSVG });
  }
}
export default pureNoFunc(Translation);
